export const getPercentage = (currentValue, total) => Math.floor((currentValue / total) * 100 + 0.5)
